import { Component, OnInit } from '@angular/core';
import { DeviceService, Device } from '../../Device-Service/device.service';
import { formatDistanceToNow } from 'date-fns';
import { utcToZonedTime, format } from 'date-fns-tz';
import { de } from 'date-fns/locale';

@Component({
  selector: 'app-device-list',
  templateUrl: './device-list.component.html',
  styleUrls: ['./device-list.component.css']
})
export class DeviceListComponent implements OnInit {
  devices: Device[] = [];
  private intervalId: any;

  constructor(private deviceService: DeviceService) { }

  ngOnInit(): void {
    this.loadDevices();

    this.intervalId = setInterval(() => {
      this.loadDevices();
    }, 5000); // 5000 ms = 5 Sekunden

  }

  ngOnDestroy(): void {
    // Intervall stoppen, wenn die Komponente zerstört wird
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  loadDevices(): void {
    this.deviceService.getDevices().subscribe((data) => {
      this.devices = data;
    });
  }

  // Prüfen, ob das Gerät online ist (LifeBit innerhalb von 1 Minute)
  isOnline(lastLifeBit: string): boolean {
    const lastLifeBitTime = new Date(lastLifeBit);
    const utcDate = new Date(lastLifeBitTime + 'Z').getTime();
    const currentTime = Date.now();


    

    return (currentTime - utcDate) / 1000 <= 180; // Unterschied in Sekunden
  }

  formatDate(lastLifeBit: string): number {
    const lastLifeBitTime = new Date(lastLifeBit);
    const utcDate = new Date(lastLifeBitTime + 'Z').getTime();// Zeitstempel von lastLifeBit in Millisekunden
    const currentTime = Date.now(); // Aktueller Zeitstempel in Millisekunden

    // Differenz in Millisekunden -> Umwandeln in Minuten
    const differenceInMinutes = Math.floor((currentTime - utcDate) / (1000 * 60));

    // Loggen der beiden Zeitwerte und des Unterschieds
    console.log('Last LifeBit Time:', lastLifeBitTime);
  

    return differenceInMinutes;
  }


}
